// Legacy agent-detail URL — moved to `/agents/:agentId` with the unified
// Agents page (2026-07 nav review). Keeps old bookmarks/shared links alive.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/workflows/agents/$agentId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/agents/$agentId',
      params: { agentId: params.agentId },
      replace: true,
    });
  },
  component: () => null,
});
